import React from "react";
//import { Link } from "gatsby";
import PropTypes from "prop-types";
//import { XMarkIcon } from "@heroicons/react/outline";

//import StrapiLogo from "~/images/strapi.png";
import Navbar from "~/components/navbar";
//import BurgerMenu from "~/components/BurgerMenu";
//import Bar from "~/components/bar";
//import DesktopMenu from "~/components/DesktopMenu";

const Header = ({ setOpenModal }) => {
	return (
		<header>
			<a name="top"></a>

			{/* <Bar /> */}
			<Navbar />
			{/* <DesktopMenu />
			<BurgerMenu /> */}
			{/* <nav className="relative flex flex-wrap items-center justify-between px-2 py-3 shadow-sm">
            <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
              <div className="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start">
                <a
                  className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-black"
                  href="#pablo"
                >
                  Art of Bicycle Trips
                </a>
                <button
                  className="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
                  type="button"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  <span class="block relative w-6 h-px rounded-sm bg-black"></span>
                  <span class="block relative w-6 h-px rounded-sm bg-black mt-1"></span>
                  <span class="block relative w-6 h-px rounded-sm bg-black mt-1"></span>
                  
                </button>
              </div>
              <div
                className={
                  "lg:flex flex-grow items-center" +
                  (menuOpen ? " flex" : " hidden")
                }
                id="example-navbar-info"
              >
                <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
                  <li className="group inline-block relative">
                    <a
                      className="mx-5 my-2 flex text-sm uppercase text-menutext hover:opacity-75"
                      href="#"
                    >
                      destinations
                    </a>
                    <ul class="absolute hidden text-gray-700 pt-4 group-hover:block">
          <li class="">
            <a
              class="rounded-t bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-nowrap"
              href="#"
              >One</a
            >
          </li>
          <li class="">
            <a
              class="bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-nowrap"
              href="#"
              >Two</a
            >
          </li>
          <li class="">
            <a
              class="rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-nowrap"
              href="#"
              >Three is the magic number</a
            >
          </li>
        </ul>
                  </li>
                  <li className="nav-item">
                    <a
                      className="mx-5 my-2 flex  text-sm uppercase text-menutext hover:opacity-75"
                      href="#"
                    >
                      tours
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="mx-5 my-2 flex text-sm uppercase text-menutext hover:opacity-75"
                      href="#"
                    >
                      about us
                    </a>
                    
                  </li>
                  
                  <button
                    className="bg-primary text-white mx-5 rounded-full text-sm uppercase py-1 px-4"
                    onClick={() => setOpenModal(true)}
                  >
                    Find Trip
                  </button>
                  
                </ul>
                
              </div>
            </div>
            
          </nav> */}

			{/* <div className="flex flex-col items-center">
        <Link className="mx-2 text-lg w-40 mb-4" to="/">
          <img src={StrapiLogo} alt="strapi catalog logo" />
        </Link>
        <div className="flex flex-col items-center md:flex-row">
          <Link className="mx-2 mb-2 md:mb-0 text-lg" to="/">
            Categories
          </Link>
          <Link className="mx-2 mb-2 md:mb-0 text-lg" to="/products">
            Products
          </Link>
          <button
            className="mx-2 mb-2 md:mb-0 text-lg"
            onClick={() => setOpenModal(true)}
          >
            Search
          </button>
        </div>
      </div> */}
		</header>
	);
};

Header.propTypes = {
	siteName: PropTypes.string,
};

Header.defaultProps = {
	siteName: ``,
};

export default Header;
